import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { routes } from '../../app.routes';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  imports: [MatListModule , MatIconModule , RouterModule,CommonModule],
  standalone: true,
})
export class SideNavComponent implements OnInit {
   @Output() menuSelected = new EventEmitter<void>();

  routes: any[] = [
    {
            path: "updatePrice",
            data: { icon: "price_change", text: "Update Price" }
          },
          {
            path: "user",
            data: { icon: "person_add", text: "Create User" }
          },{
            path: "recordPayment",
            data: { icon: "payment", text: "Record Payment" }
          },{
            path: 'download-receipt',
            data: { icon: "download", text: "Download Receipt" }
          }
  ];
  constructor(
    ) {}

  ngOnInit() {}

   menuClicked() {
    this.menuSelected.emit();
  }
}
